import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { StreamData } from 'types/streamData'
import SourceType from 'enums/SourceType'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import LikeIcon from './LikeIcon'
import ReplyIcon from './ReplyIcon'
import RetweetIcon from './RetweetIcon'
import ViewOnIcon from './ViewOnIcon'

type ActionIconsProps = {
  streamData: StreamData
  displayText?: boolean
  iconColor?: string
  isCompact?: boolean
}

const TwitterDivider = styled.div`
  width: 1px;
  height: 16px;
  background: ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
  margin: 0 10px;
`

const ActionIcons = ({
  streamData,
  displayText,
  iconColor,
  isCompact = false
}: ActionIconsProps) => {
  const theme = useDisplayTheme() as Theme
  const { sourceType, postId, domain, url } = streamData
  const isTwitter = sourceType === SourceType.TWITTER

  return (
    <>
      {isTwitter && <ReplyIcon postId={postId!} displayText={displayText} iconColor={iconColor} />}
      {isTwitter && (
        <RetweetIcon postId={postId!} displayText={displayText} iconColor={iconColor} />
      )}
      {isTwitter && <LikeIcon postId={postId!} displayText={displayText} iconColor={iconColor} />}
      {isTwitter && isCompact && <TwitterDivider mode={theme} />}
      {sourceType && url && (
        <ViewOnIcon
          source={sourceType!}
          domain={domain!}
          url={url}
          displayText={displayText}
          iconColor={iconColor}
        />
      )}
    </>
  )
}

export default ActionIcons
